<template>
    <ValidationProvider 
            :name="field"
            :rules="rules"
            v-slot="{ errors }"
            slim
        >
        <!-- Autocomplete Function inkl. Freetext, means user can add individual dropdown option -->
        <v-combobox 
            v-if="withFreeText"
            v-model="selectedEntry"
            :items="entries"
            :label="label"
            :search-input.sync="searchString"
            hide-no-data
            :hide-details="hideDetails"
            :loading="isLoading"
            v-bind="$attrs"
            v-on="$listeners"
            no-filter
            :clearable="clearable"
            :return-object="returnObject"
            :multiple="multiple"
            :error-messages="errors"
            :class="withMargin ? 'ml-4 mr-4' : ''" 
            @click:clear="resetVal()"
            @change="additionalFunction(selectedEntry)"
            :alvqa="alvqa"
            :item-value="itemValue"
            :disabled="disabled"
        >
            <template v-slot:selection="{ item }">
                <slot name="selection" :item="item"></slot>
            </template>
            <template v-slot:item="{ item }">
                <slot name="items" :items="item"></slot>
            </template>
        </v-combobox>
         <!-- Autocomplete Function without Freetext -->
        <v-autocomplete
            v-else
            v-model="selectedEntry"
            :items="entries"
            :label="label"
            :search-input.sync="searchString"
            hide-no-data
            :hide-details="hideDetails"
            :loading="isLoading"
            :clearable="clearable"
            :return-object="returnObject"
            no-filter
            :multiple="multiple"
            :error-messages="errors"
            :menu-props="{'closeOnClick': true, 'closeOnContentClick': true}"
            :class="withMargin ? 'ml-4 mr-4' : ''" 
            @click:clear="resetVal()"
            @change="additionalFunction(selectedEntry)"
            :alvqa="alvqa"
            :item-value="itemValue"
            :disabled="disabled"
        >
            <template v-slot:selection="{ item }">
                <slot name="selection" :item="item"></slot>
            </template>
            <template v-slot:item="{ item }">
                <slot name="items" :items="item"></slot>
            </template>
        </v-autocomplete>
    </ValidationProvider>
</template>

<script>
import VCombobox from 'vuetify/es5/components/VCombobox'

export default {
    name: "BaseEditPageAutocomplete",
    extends: VCombobox,
    props: {
        context: String,
        field: String,
        required: Boolean,
        rules: {
            type: [Object, String],
            default: ""
        },
        withMargin: {
            type: Boolean,
            default: true
        },
        withFreeText: {
            type: Boolean,
            default: true
        },
        additionalFunction: {
            type: Function,
            default: () => {}
        },
        clearable: {
            type: Boolean,
            default: true
        },
        alvqa: {
            type: String,
            default: ''
        },
        returnObject: {
            type: Boolean,
            default: true
        },
        searchAtChar: { // at which character the search should start
            type: Number,
            default: 3
        },
        itemValue: {
            type: String,
            default: 'value'
        }
    },
    data() {
        return {
            searchString: null,
            debouncedFunction: null
        }
    },
    computed: {
        selectedEntry: {
            get() { return this.$store.getters[`get${this.context}Details${this.field}`] },
            set(selected) { this.$store.commit(`set${this.context}Details${this.field}`, selected) }
        },
        entries: {
            get() { return this.$store.getters[`get${this.context}${this.field}Options`] },
            set(values) { this.$store.commit(`set${this.context}${this.field}Options`, values) }
        },
        isLoading: {
            get() { return this.$store.getters.getIsLoading },
            set(isLoading) { this.$store.commit('setIsLoading', isLoading)}
        }
    },
    methods: {
        async searchInBackend() {
            if(this.searchString && this.searchString.length >= this.searchAtChar) {
                this.isLoading = true
                await this.$store.dispatch(`fetchAutocomplete${this.context}${this.field}`, this.searchString)
                this.isLoading = false
            }
        },
        async resetVal() {
            await this.$nextTick()
            this.selectedEntry = null
            this.entries = []
        }
    },
    watch: {
        searchString (search) {
            if (search && search !== this.selectedEntry) {
                this.debouncedFunction()
            }
        },
    },
    created () {
        this.debouncedFunction = _.debounce(this.searchInBackend, 400);
    }
}
</script>